@for (bubble of bubbles(); track bubble) {
  <div class="audio-bubble absolute inset-0 size-[100%] rounded-full bg-emerald-500/50" (animationend)="remove(bubble)"></div>
}
